import { useRef, useEffect } from 'react';
import { Inspector } from 'fsm';
export function useAuthFlowInspector(debug, appName) {
  var _inspectorRef$current;
  const inspectorRef = useRef(null);
  if (debug && !inspectorRef.current) {
    inspectorRef.current = new Inspector({
      name: `AuthFlowMachine-${appName}`,
      maxTimelineSize: 200,
      initialStatus: 'running'
    });
  }
  useEffect(() => {
    if (debug && inspectorRef.current) {
      const timeline = inspectorRef.current.getTimeline();
      console.log(`[DEBUG ${appName} Auth Flow Inspector] Timeline:`, new Date().toUTCString(), timeline);
    }
  }, [debug, appName, (_inspectorRef$current = inspectorRef.current) === null || _inspectorRef$current === void 0 ? void 0 : _inspectorRef$current.timeline.length]);
  return inspectorRef.current;
}